import { jsx as _jsx } from "react/jsx-runtime";
export default function LegendItem(_ref) {
  let {
    flexDirection = 'row',
    alignItems = 'center',
    margin = '0',
    display = 'flex',
    children,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "visx-legend-item",
    style: {
      display,
      alignItems,
      flexDirection,
      margin
    },
    ...restProps,
    children: children
  });
}